import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function usePatientAvailableProviders(patientId, query, options = {}) {
  return useQuery({
    queryKey: QK.patients.id(patientId).providers.list(query),
    queryFn: () => API.patients.id(patientId).providers.list(query),
    ...options,
  })
}
